import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

import '@services/firebase'

import '@sass/App.sass'
import 'react-image-lightbox/style.css'
import 'react-toastify/dist/ReactToastify.css'

import * as serviceWorker from './serviceWorker'

ReactDOM.render(<App />, document.getElementById('root'))

serviceWorker.unregister()
